import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppState } from '../redux/store/rootReducer';
import { loadSingleUser, loadToken, loadUserInfo } from './login/loginSlice';
import FurronLogo from '../assets/img/furon.svg';
import SGLogo from '../assets/img/SGlogo.svg';
import { Button } from 'antd';
import { isAuthenticated } from '../services/authenticationService';
import React from 'react';
import { getVerifier } from "../services/pkceService";

const DashboardPage: FC = () => {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const fields = useSelector((state: AppState) => state.authentication);
    const [isAcessAllowed, setAccess] = useState(true);
    const verifier = getVerifier();
    useEffect(() => {
        if (isAuthenticated()) {
            navigate('/users');
        }
    })
    useEffect(() => {
        if (fields.isAccessAllowed && fields.isProcessingComplete) {
            navigate('/users')
        } else if (fields.isProcessingComplete) {
            setAccess(fields.isAccessAllowed)
        } else if (fields.isTokenSet) {
            dispatch(loadUserInfo(process.env.REACT_APP_ACCESS_MANAGEMENT + "userinfo"))
        } else if (fields.isUserInfoSet) {
            dispatch(loadSingleUser(fields.userSgid))
        }
    }, [fields])


    useEffect(() => {
        let code = 'no-code';
        const authCode: string | null = extractAuthCode(window.location.href);
        if (authCode != null) {
            code = authCode;
            const url = process.env.REACT_APP_ACCESS_MANAGEMENT + "token" +
                '?grant_type=authorization_code&code=' + code +
                '&client_id=' + process.env.REACT_APP_CLIENT_ID +
                '&redirect_uri=' + process.env.REACT_APP_REDIRECT_URI +
                '&code_verifier=' + verifier

            dispatch(loadToken(url))
        }
    }, []);

    const openLogin: any = (e: Event) => {
        e.preventDefault();
        navigate('/login')
    }

    const AccessNotAllowed = () => (
        <>
            <p> You have no access to this app, please contact the admin</p>
            <div style={{ paddingTop: '5%' }}>
                <Button type="primary" className='loginbutton' onClick={openLogin}>
                    Go back to login</Button>
            </div>
        </>
    )

    const AccessAllowed = () => (
        <>
            <p> Welcome to Furon Fitting Configurator Backoffice</p>
            <div style={{ paddingTop: '5%' }}>
                <Button type="primary" className='loginbutton' loading>
                    Login with SSO</Button>
            </div>
        </>
    )
    return (
        <div className='container'>
            <div className="content-container">
                <img src={FurronLogo} alt="" />
                {isAcessAllowed ? <AccessAllowed /> : <AccessNotAllowed />}
            </div>
            <div className='sglogo'>
                <img src={SGLogo} alt="" />
                <p style={{ fontSize: '12px', padding: '0' }}>V1.0</p>
            </div>
        </div>
    );
};

export const extractAuthCode = (url: string): string | null => {
    let authCode = null
    authCode = url.match(/code=(.*?)&/i);
    if (authCode != null) {
        authCode = authCode[1]
    }
    return authCode;
};

export default DashboardPage;